import React, { FC, Fragment } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ReportNames, usePostOverviewStatsLazyQuery } from 'api';
import { useClient, useDateRange, useNotify } from 'hooks';
import { DatePickers, PaddedPaper } from 'components';

import {
  ControlWrapper,
  DailyPostStatsChart,
  DownloadButton,
  NewApprovedPostChart,
  PostDashboardStatTable,
} from '../components/Analytics';

const AnalyticsPosts: FC = () => {
  const client = useClient();
  const notify = useNotify();
  const { t } = useTranslation();
  const { startDate, setStartDate, endDate, setEndDate, dateRange, setDateRange } = useDateRange();

  const [statsQuery] = usePostOverviewStatsLazyQuery({
    variables: {
      client_id: client.id,
      start_date: startDate,
      end_date: endDate,
      report: ReportNames.Posts,
    },
    fetchPolicy: 'network-only',
    onCompleted: () => notify.info({ message: t('analytics:reportRequested') }),
    onError: () => notify.error({ message: t('analytics:reportRequestedError') }),
  });

  return (
    <Fragment>
      <Grid container alignItems="center" justify="space-between">
        <Grid item>
          <Typography paragraph variant="h5" color="textSecondary">
            {t('analytics:approved_new_posts')}
          </Typography>
        </Grid>
        <Grid item>
          <DownloadButton onClick={statsQuery} />
        </Grid>
      </Grid>
      <Grid container direction="column" spacing={4} wrap="nowrap">
        <Grid item>
          <PaddedPaper padding={12}>
            <ControlWrapper>
              <DatePickers.Range
                dateRange={dateRange}
                startDate={startDate}
                endDate={endDate}
                onSetStart={setStartDate}
                onSetEnd={setEndDate}
                onSetRange={setDateRange}
              />
            </ControlWrapper>
          </PaddedPaper>
        </Grid>
        <Grid item>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <NewApprovedPostChart startDate={startDate} endDate={endDate} />
            </Grid>
            <Grid item xs={8}>
              <DailyPostStatsChart startDate={startDate} endDate={endDate} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <PostDashboardStatTable startDate={startDate} endDate={endDate} />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default AnalyticsPosts;
